module.exports = __webpack_public_path__ + "img/step4_zh-CN.d3982db5.png";